import styles from "./PricingExamples.module.css";
import {
  BoxSeamFill,
  ArrowsAngleExpand,
  Tag,
  Truck,
} from "react-bootstrap-icons";

const PricingExamplesCard = ({ data, index, providerImg, providerText }) => {
  return (
    <article className={styles.card} style={{ "--i": index }}>
      <div className={styles.cardHeader}>
        <div className={styles.provider}>
          <span className={styles.providerLogo}>
            <img src={providerImg} alt={providerText} />
          </span>
          <span className={styles.providerName}>{providerText}</span>
        </div>

        <span className={styles.cardBadge}>نمونه {index + 1}</span>
      </div>

      <div className={styles.route}>
        <div className={styles.city}>
          <span className={`${styles.cityDot} ${styles.cityDotStart}`}></span>
          <span className={styles.cityLabel}>مبدا</span>
          <span className={styles.cityName}>{data.from}</span>
        </div>

        <div className={styles.routeLine}>
          <span className={styles.routeIcon}>
            <Truck size={16} />
          </span>
        </div>

        <div className={`${styles.city} ${styles.cityEnd}`}>
          <span className={`${styles.cityDot} ${styles.cityDotEnd}`}></span>
          <span className={styles.cityLabel}>مقصد</span>
          <span className={styles.cityName}>{data.to}</span>
        </div>
      </div>

      <ul className={styles.specs}>
        <li className={styles.spec}>
          <BoxSeamFill size={13} />
          <span>{data.weight}</span>
        </li>

        <li className={styles.spec}>
          <ArrowsAngleExpand size={13} />
          <span>{data.size}</span>
        </li>

        <li className={styles.spec}>
          <Tag size={13} />
          <span>{data.value}</span>
        </li>
      </ul>

      <div className={styles.price}>
        <span className={styles.priceTitle}>هزینه ارسال</span>
        <span className={styles.priceValue}>
          <strong>{data.shippingCost}</strong>
          <small>تومان</small>
        </span>
      </div>
    </article>
  );
};

export default PricingExamplesCard;
